import React from 'react';
import { useRsvpStatus, RsvpStatus } from './hooks/useRsvpStatus';
import { RsvpDetailsPanel } from './components/RsvpDetailsPanel';
import { RsvpActionButton } from './components/RsvpActionButton';
import { useNavigate } from 'react-router-dom';
interface RsvpAccordionContentProps {
  eventId: string;
  currentStatus?: RsvpStatus;
}
export const RsvpAccordionContent: React.FC<RsvpAccordionContentProps> = ({
  eventId,
  currentStatus
}) => {
  const navigate = useNavigate();
  const hasResponded = currentStatus !== undefined && currentStatus !== 'invited';
  const {
    rsvpDetails,
    rsvpUpdateAllowed,
    checkingRsvpStatus,
    displayDates,
    displayTimes
  } = useRsvpStatus(eventId, hasResponded);
  const handleUpdateRsvp = () => {
    if (eventId) {
      if (hasResponded) {
        navigate(`/events/${eventId}/update-rsvp`);
      } else {
        navigate(`/events/${eventId}/rsvp`);
      }
    }
  };
  if (!currentStatus || currentStatus === 'invited') {
    return <div className="flex flex-col gap-4 p-4">
        <p className="text-sm text-gray-500">You haven't responded to this invitation yet</p>
        
        {eventId && <RsvpActionButton eventId={eventId} hasResponded={false} rsvpUpdateAllowed={true} checkingRsvpStatus={false} onUpdateRsvp={handleUpdateRsvp} />}
      </div>;
  }
  return <div className="flex flex-col gap-4 p-2">
      {currentStatus === 'accepted' && rsvpDetails && <RsvpDetailsPanel details={rsvpDetails} displayDates={displayDates} displayTimes={displayTimes} />}
      
      {eventId && <RsvpActionButton eventId={eventId} hasResponded={hasResponded} rsvpUpdateAllowed={rsvpUpdateAllowed} checkingRsvpStatus={checkingRsvpStatus} onUpdateRsvp={handleUpdateRsvp} />}
    </div>;
};